/* eslint-disable react/require-default-props */
import * as React from 'react';
import {Image, View} from 'react-native';
import Chance from 'chance';

import {styles} from './Avatar.style';
import clientAvatar from './client_avatar.png';
import coachAvatar from './coach_avatar.png';

const COLUMNS = 6;
const ROWS = 4;
const NUM_ROTATIONS = 4;
const TOTAL_COMBINATIONS = COLUMNS * ROWS * NUM_ROTATIONS;

interface DefaultAvatarProps {
  size: number;
  variant: 'coach' | 'client';
  avatarKey: string;
  accessible?: boolean;
  accessibilityRole?: string;
  accessibilityLabel?: string;
  nativeID?: string;
  testID?: string;
}

const DefaultAvatar: React.FC<DefaultAvatarProps> = ({
  size = 40,
  variant = 'client',
  avatarKey = 'seed',
  accessible = true,
  accessibilityRole,
  accessibilityLabel,
  nativeID,
  testID,
}) => {
  // Switch which image source we are using based on the `variant`
  const avatar = variant === 'client' ? clientAvatar : coachAvatar;

  const width = size * COLUMNS;
  const height = size * ROWS;

  // From the avatarKey (likely the user's email) we will create a random
  // seed, and use that to figure out which avatar/rotation we want to use.
  // The seed will be a big number, so the best we can do is just mod it
  // by the number of possibilities to make it as-random-as-possible™️
  const seed = Math.abs(new Chance(avatarKey).seed) % TOTAL_COMBINATIONS;

  // Figure out which x and y coordinates in the image grid we want to use
  // for this seed. There are COLUMNS*ROWS possible cells, but we
  // can rotate each one NUM_ROTATIONS times.
  const x = Math.floor(seed / NUM_ROTATIONS) % (COLUMNS - 1);
  const y = Math.floor(seed / (COLUMNS * NUM_ROTATIONS));

  // Figure out how much to rotate our avatar.
  const rot = (seed % NUM_ROTATIONS) * (360.0 / NUM_ROTATIONS);

  const style = [styles.base];
  // @ts-expect-error TS(2345): Argument of type '{ width: any; height: any; }' is... Remove this comment to see the full error message
  style.push({width: size, height: size});

  const rotationStyle = [styles.rotation];
  // Set width and height with rotation otherwise rotation appears to apply to a
  // larger area which means the transform origin is incorrect and the image
  // actually rotates out of our area of focus.
  // @ts-expect-error TS(2345): Argument of type '{ width: any; height: any; }' is... Remove this comment to see the full error message
  rotationStyle.push({width: size, height: size});
  // @ts-expect-error TS(2345): Argument of type '{ transform: { rotate: string; }... Remove this comment to see the full error message
  rotationStyle.push({transform: [{rotate: `${rot}deg`}]});

  const imageStyle = [styles.image];
  // @ts-expect-error TS(2345): Argument of type '{ width: number; height: number;... Remove this comment to see the full error message
  imageStyle.push({width: width, height: height});
  imageStyle.push({
    // @ts-expect-error TS(2345): Argument of type '{ transform: ({ translateX: numb... Remove this comment to see the full error message
    transform: [{translateX: -(x * size)}, {translateY: -(y * size)}],
  });

  return (
    <View
      style={style}
      accessible={accessible}
      accessibilityRole={accessibilityRole}
      accessibilityLabel={accessibilityLabel}
      nativeID={nativeID}
      testID={testID}>
      <View style={rotationStyle}>
        <Image
          source={avatar}
          style={imageStyle}
          importantForAccessibility="no"
        />
      </View>
    </View>
  );
};

export default DefaultAvatar;
